import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.963 4.144A7.5 7.5 0 0 0 12 11.5a1 1 0 1 1-2 0q0-.738.113-1.46a4 4 0 0 0-.608-.04H9.5a4.5 4.5 0 1 0 0 9h10a7.5 7.5 0 0 0 1.463-14.856M10.63 8.097A9.5 9.5 0 1 1 19.5 21h-10a6.5 6.5 0 0 1-.003-13"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.5 26a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M14.5 28a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M20.5 26a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8.5 31a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M19.5 31a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    />
  </svg>
);
const SvgIconCloudSnow = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCloudSnow);
export default Memo;
